// extracted by mini-css-extract-plugin
export default {"textArea":"textArea_textArea__jBWX6"};